<template>
  <div id="app">
    <div id="app-content">
      <BaseLoading />
      <RouterView />
    </div>
    <Notifications group="right" position="bottom right">
      <template #body="{ item, close }">
        <BaseNotification :item="item" :close="close" />
      </template>
    </Notifications>
    <Notifications group="app" classes="sbnotify" position="top center">
      <template #body="{ item, close }">
        <BaseNotification :item="item" :close="close" />
      </template>
    </Notifications>
    <DiscardChangesModal />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Notifications } from '@kyvg/vue3-notification'
import { useProvideTheme } from '@/composables/theme/useTheme'
import { useTracking } from '@/store/modules/App/tracking'
import BaseLoading from '@base/BaseLoading.vue'
import BaseNotification from '@base/BaseNotification.vue'
import DiscardChangesModal from '@/components/ContentManager/DiscardChanges/DiscardChangesModal.vue'
import { useDynamicBackendApiEndpoint } from './composables/useDynamicBackendApiEndpoint'
import { useApplication } from './store/modules/App/application'

// explicitly defined to show it in Vue DevTools
defineOptions({
  name: 'StoryfrontApp',
})

useTracking()

const router = useRouter()
const route = useRoute()
const applicationStore = useApplication()
useDynamicBackendApiEndpoint({ route, router })

onMounted(() => {
  if (!route.params.spaceId && !route.params.orgId && route.meta.title) {
    applicationStore.setTitle(route.meta.title)
  }
  setAppHeight()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

watch(
  () => route.meta.title,
  () => {
    if (!route.params.spaceId && !route.params.orgId && route.meta.title) {
      applicationStore.setTitle(route.meta.title)
    }
  },
)

useProvideTheme()

const handleResize = () => {
  setAppHeight()
}

const setAppHeight = () => {
  const doc = document.documentElement
  if (doc) {
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
}
</script>
